/* esm.sh - @radix-ui/react-focus-guards@1.1.3 */
export * from "/*@radix-ui/react-focus-guards@1.1.3/esnext/react-focus-guards.mjs";
